import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["useGap", "message", "options"];
import { useContext, createElement } from 'react';
// @ts-expect-error untyped JS module
import { classNameFix, getPassThroughProps, getValue } from './utils';
import { I18nHMRContext } from '../internal/i18n-internal';
const DEFAULT_OPTIONS = {};
function FormattedHTMLMessage(t0) {
  const {
      useGap: t1,
      message,
      options: t2
    } = t0,
    rest = _objectWithoutPropertiesLoose(t0, _excluded);
  const useGap = t1 === undefined ? false : t1;
  const options = t2 === undefined ? DEFAULT_OPTIONS : t2;
  useContext(I18nHMRContext);
  const props = classNameFix(getPassThroughProps(Object.assign({
    useGap,
    message,
    options
  }, rest)));
  return /*#__PURE__*/createElement("i18n-string", Object.assign({}, props, {
    dangerouslySetInnerHTML: {
      __html: getValue({
        useGap,
        message,
        options
      })
    }
  }));
}
FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.isI18nElement = true;
export default FormattedHTMLMessage;